var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 32,
    viewBox: "0 0 150 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P4L full logo (1) 1",
    clipPath: "url(#clip0_4388_20111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2669 0H23.0355V15.1362H26.9625V22.7242H22.995V31.2408H9.27073C13.4554 26.4833 15.2758 21.9608 16.1123 19.2932C17.4622 14.9897 17.692 10.9165 17.8124 8.78856C17.9309 6.69197 17.9019 4.924 17.8463 3.63904C17.392 5.88999 16.1274 10.577 12.2663 15.0548C7.85791 20.167 2.60216 22.0646 0.404297 22.7236C0.633518 20.6385 0.863344 18.5528 1.09256 16.4676C2.69288 15.785 5.79008 14.204 8.37986 10.8978C11.8684 6.44474 12.221 1.68776 12.2669 0Z",
    fill: "#1881C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.75307 9.43126C4.27355 9.43126 5.50614 8.20237 5.50614 6.68645C5.50614 5.17054 4.27355 3.94165 2.75307 3.94165C1.23259 3.94165 0 5.17054 0 6.68645C0 8.20237 1.23259 9.43126 2.75307 9.43126Z",
    fill: "#1881C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.1011 18.2766V24.4229H38.0967V5.56323H45.0785C49.689 5.56323 52.5606 7.74364 52.5606 11.8409C52.5606 15.9383 49.689 18.2766 45.0785 18.2766H42.1017H42.1011ZM42.1011 8.9255V14.9144H45.0519C47.3175 14.9144 48.5822 13.7325 48.5822 11.8675C48.5822 10.0024 47.3175 8.9255 45.0519 8.9255H42.1011Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M62.2826 22.6893C61.3603 24.0026 59.9644 24.6858 58.0411 24.6858C55.1169 24.6858 53.167 22.9788 53.167 20.3515C53.167 17.7243 55.38 16.1487 59.4902 16.1487C60.2807 16.1487 60.9653 16.2012 61.8351 16.3061V15.4655C61.8351 13.8893 60.9393 12.9704 59.411 12.9704C57.8827 12.9704 56.8817 13.8899 56.7499 15.4655H53.4567C53.6672 12.2347 56.012 10.1333 59.411 10.1333C63.0997 10.1333 65.2601 12.1557 65.2601 15.597V24.4229H62.2832V22.6893H62.2826ZM58.831 22.1641C60.7016 22.1641 61.8344 21.1397 61.8344 19.511V18.513C60.9647 18.3816 60.3593 18.3291 59.7267 18.3291C57.6456 18.3291 56.618 18.9858 56.618 20.2466C56.618 21.4285 57.4611 22.1641 58.831 22.1641Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M76.1664 24.055C75.2707 24.5018 74.4276 24.6851 73.3474 24.6851C70.4492 24.6851 68.6317 23.0305 68.6317 19.8781V13.5214H65.7861V10.3955H68.6317V6.24512H72.2672V10.3955H76.2982V13.5214H72.2672V19.0375C72.2672 20.6662 73.0051 21.3228 74.3223 21.3228C75.0076 21.3228 75.6396 21.1655 76.1664 20.876V24.0544V24.055Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M81.4101 24.4229H77.748V5.56323H81.4101V12.2353C82.3851 10.9479 83.5971 10.1339 85.4412 10.1339C88.2602 10.1339 90.21 11.9724 90.21 15.3612V24.4235H86.5746V16.5961C86.5746 14.5212 85.7581 13.3653 84.0979 13.3653C82.6488 13.3653 81.4107 14.5212 81.4107 16.78V24.4235L81.4101 24.4229Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M103.435 20.9291V24.4228H99.7998V20.9291H91.3428V18.2235L100.538 6.66602H103.436V17.7508H105.939V20.9291H103.436H103.435ZM99.7998 17.7508V11.8933L95.3472 17.7508H99.7998Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M107.781 24.4229V5.56323H111.786V20.8243H120.006V24.4229H107.781Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M123.431 9.29332C122.008 9.29332 121.007 8.37376 121.007 7.13944C121.007 5.90512 122.008 4.93311 123.431 4.93311C124.854 4.93311 125.881 5.85266 125.881 7.13944C125.881 8.42622 124.88 9.29332 123.431 9.29332ZM121.639 24.4229V10.3962H125.302V24.4229H121.639Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M129.121 24.4229V13.5221H126.275V10.3962H129.121V9.63462C129.121 6.85002 130.623 5.27441 133.547 5.27441C134.443 5.27441 135.207 5.43179 135.813 5.6947V8.58422C135.418 8.42684 134.89 8.34785 134.416 8.34785C133.415 8.34785 132.756 8.7416 132.756 9.71362V10.3968H136.419V13.5227H132.756V24.4235H129.121V24.4229Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M136.181 17.357C136.181 13.1807 139.106 10.1338 143.163 10.1338C147.616 10.1338 150.567 13.7324 149.908 18.3031H139.923C140.16 20.5884 141.266 21.8493 143.137 21.8493C144.743 21.8493 145.824 21.0611 146.245 19.6688H149.881C149.09 22.8472 146.64 24.6598 143.215 24.6598C139 24.6598 136.181 21.7443 136.181 17.3576L136.181 17.357ZM139.975 15.9912H146.035C145.93 14.0472 144.823 12.8129 143.084 12.8129C141.345 12.8129 140.291 13.9163 139.975 15.9912Z",
    fill: "#211D50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.6035 28.4961L39.718 31.2651H39.1785L39.9249 28.9442H38.4824V27.8196H38.9995V28.4961H40.6041H40.6035Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M40.8643 29.1678L41.2193 28.106H41.6553V28.1687L41.206 29.1678H40.8643ZM41.6281 29.1678L41.9831 28.106H42.4192V28.1687L41.9741 29.1678H41.6281Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M44.4418 29.7996L44.172 30.0239L44.9044 31.2649H42.8505V30.8169H44.0462V30.7855L42.6709 28.496H43.2594L43.9289 29.6296L44.091 29.4993C44.1956 29.4125 44.2694 29.3251 44.3111 29.237C44.3529 29.149 44.374 29.0362 44.374 28.8988V28.4954H44.8772V28.9434C44.8772 29.1225 44.8421 29.2786 44.7714 29.4119C44.7012 29.5452 44.5905 29.6742 44.4412 29.7996H44.4418Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M45.2686 28.9441V28.4961H46.783V28.9441H46.5042C46.3874 28.9441 46.2991 29.0123 46.2393 29.1479C46.1794 29.2842 46.1492 29.4639 46.1492 29.6876C46.1492 29.7684 46.1582 29.898 46.1764 30.0771L46.3294 31.2644H45.8123L45.6732 30.1489C45.649 29.9668 45.6375 29.8082 45.6375 29.6737C45.6375 29.3421 45.7197 29.0985 45.8849 28.9435H45.2692L45.2686 28.9441Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M48.375 28.4961H49.0131V30.0596H48.375V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M49.4219 28.4961H50.0599V31.265H49.4219V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M52.6898 28.496L51.8086 31.2649H51.1433L51.8491 29.0423H50.501V27.8188H51.1439V28.4954H52.6898V28.496Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M54.68 29.0423H53.0664V28.4954H55.3181V31.2643H54.68V29.0417V29.0423ZM53.1027 31.2649V29.7098H53.7547V31.2649H53.1027Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M56.9727 28.4961H57.6379V32.0001H56.9727V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M58.0781 29.0423V28.4954H59.1432C59.4395 28.4954 59.6718 28.59 59.8399 28.78C60.0074 28.9699 60.0915 29.2334 60.0915 29.5711V31.2649H59.4535V29.6248C59.4535 29.4216 59.4147 29.2738 59.3367 29.181C59.2587 29.0887 59.1226 29.0423 58.9279 29.0423H58.0781Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M62.1683 29.0423H60.5547V28.4954H62.8064V31.2643H62.1683V29.0417V29.0423ZM60.591 31.2649V29.7098H61.243V31.2649H60.591Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M65.0536 30.176L65.7322 31.265H64.9816L64.1548 29.93L64.0829 29.9837C64.0139 30.0313 63.9643 30.0874 63.9347 30.1519C63.9045 30.2164 63.8899 30.3063 63.8899 30.4232V31.2656H63.2924V30.4142C63.2924 30.053 63.4031 29.7913 63.625 29.6303L63.841 29.4735L63.2295 28.4967H63.9758L64.7445 29.7153L64.8522 29.6345C64.9272 29.5779 64.9804 29.5188 65.0119 29.4573C65.0433 29.3964 65.059 29.3011 65.059 29.1726V28.4961H65.6566V29.1907C65.6566 29.3638 65.6275 29.5151 65.5689 29.6436C65.5102 29.772 65.411 29.8932 65.2701 30.0066L65.0542 30.1766L65.0536 30.176Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M67.2646 28.4961H69.5435V31.265H67.2646V28.4961ZM68.9049 29.043H67.9027V30.7187H68.9049V29.043Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M71.6468 29.0423H70.0332V28.4954H72.2849V31.2643H71.6468V29.0417V29.0423ZM70.0695 31.2649V29.7098H70.7215V31.2649H70.0695Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M72.7256 29.0423V28.4954H73.7906C74.087 28.4954 74.3192 28.59 74.4874 28.78C74.6549 28.9699 74.739 29.2334 74.739 29.5711V31.2649H74.1009V29.6248C74.1009 29.4216 74.0622 29.2738 73.9842 29.181C73.9062 29.0887 73.7701 29.0423 73.5753 29.0423H72.7256Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M77.0803 28.4961V30.7187H77.422V31.2656H75.1836V30.7187H76.4422V29.043H75.1836V28.4961H77.0803Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M79.5428 30.176L80.2214 31.265H79.4709L78.6441 29.93L78.5721 29.9837C78.5032 30.0313 78.4536 30.0874 78.4239 30.1519C78.3937 30.2164 78.3792 30.3063 78.3792 30.4232V31.2656H77.7816V30.4142C77.7816 30.053 77.8923 29.7913 78.1143 29.6303L78.3302 29.4735L77.7188 28.4967H78.4651L79.2338 29.7153L79.3414 29.6345C79.4164 29.5779 79.4697 29.5188 79.5011 29.4573C79.5326 29.3964 79.5483 29.3011 79.5483 29.1726V28.4961H80.1458V29.1907C80.1458 29.3638 80.1168 29.5151 80.0581 29.6436C79.9995 29.772 79.9003 29.8932 79.7594 30.0066L79.5434 30.1766L79.5428 30.176Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M83.6507 28.4961V30.817H84.0106V31.265H81.7861V30.817H83.1391V28.9441H81.7861V28.4961H83.6513H83.6507Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M84.1816 28.9441V28.4961H85.1747C85.4802 28.4961 85.7172 28.5902 85.8848 28.7783C86.0523 28.9664 86.1364 29.2293 86.1364 29.567V31.265H85.6241V29.6297C85.6241 29.3939 85.5793 29.2203 85.4892 29.1099C85.3991 28.9996 85.2449 28.9441 85.0266 28.9441H84.1816Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M88.3975 28.9441H86.6943V28.4961H88.9103V31.265H88.3981V28.9441H88.3975ZM86.7433 31.265V29.6743L87.2647 29.6786V31.265H86.7433Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M90.7256 28.4961H91.256V32.0001H90.7256V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M93.683 28.4961V30.817H94.0428V31.265H91.8184V30.817H93.1713V28.9441H91.8184V28.4961H93.6836H93.683Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M95.5889 28.4961H96.2542V32.0001H95.5889V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M98.317 28.4466H98.3443C98.5868 28.4466 98.7839 28.5287 98.9351 28.6933C99.0863 28.8579 99.1619 29.0906 99.1619 29.3921V31.265H97.9257V30.7181H98.5233V29.4814C98.5233 29.1588 98.4108 28.9972 98.1864 28.9972H98.164C98.092 28.9972 98.0037 29.0255 97.8991 29.0822C97.7945 29.1389 97.6566 29.2239 97.4854 29.3379C97.4703 29.3499 97.4576 29.3596 97.4473 29.3668C97.437 29.374 97.4256 29.3813 97.4135 29.3867V31.2644H96.7754V28.4955H97.4044L97.4177 28.8139C97.6336 28.6764 97.8005 28.5811 97.9191 28.5268C98.0376 28.4732 98.1701 28.446 98.317 28.446V28.4466Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M101.764 28.496L100.883 31.2649H100.217L100.923 29.0423H99.5752V27.8188H100.218V28.4954H101.764V28.496Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M102.097 29.0423V28.4954H103.701V29.0423H103.431C103.318 29.0423 103.232 29.1086 103.175 29.2419C103.118 29.3751 103.09 29.5458 103.09 29.755C103.09 29.8654 103.099 29.9805 103.117 30.0999L103.274 31.2649H102.627L102.488 30.2072C102.461 29.998 102.447 29.84 102.447 29.7321C102.447 29.4216 102.533 29.1912 102.704 29.0423H102.097H102.097Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M106.861 29.0423H105.247V28.4954H107.499V31.2643H106.861V29.0417V29.0423ZM105.283 31.2649V29.7098H105.935V31.2649H105.283Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M109.561 28.4466H109.588C109.831 28.4466 110.028 28.5287 110.179 28.6933C110.33 28.8579 110.406 29.0906 110.406 29.3921V31.265H109.17V30.7181H109.767V29.4814C109.767 29.1588 109.655 28.9972 109.431 28.9972H109.408C109.336 28.9972 109.248 29.0255 109.143 29.0822C109.039 29.1389 108.901 29.2239 108.73 29.3379C108.714 29.3499 108.702 29.3596 108.691 29.3668C108.681 29.374 108.67 29.3813 108.658 29.3867V31.2644H108.02V28.4955H108.649L108.662 28.8139C108.878 28.6764 109.045 28.5811 109.163 28.5268C109.282 28.4732 109.414 28.446 109.561 28.446V28.4466Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M113.009 28.496L112.128 31.2649H111.463L112.168 29.0423H110.82V27.8188H111.463V28.4954H113.009V28.496Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M113.392 28.4961H114.025V29.8944C114.025 30.1724 114.103 30.3883 114.259 30.542C114.415 30.6958 114.62 30.773 114.875 30.773H114.924C115.179 30.773 115.384 30.6964 115.54 30.542C115.696 30.3883 115.773 30.1724 115.773 29.8944V28.4961H116.407V29.8944C116.407 30.3099 116.274 30.6518 116.007 30.9207C115.741 31.1896 115.38 31.3241 114.924 31.3241H114.875C114.419 31.3241 114.058 31.1896 113.791 30.9207C113.525 30.6518 113.392 30.3099 113.392 29.8944V28.4961ZM114.592 28.4961H115.194V30.2122L114.592 30.208V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M119.93 28.4961V30.817H120.29V31.265H118.065V30.817H119.418V28.9441H118.065V28.4961H119.931H119.93Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M120.461 28.9441V28.4961H121.454C121.759 28.4961 121.997 28.5902 122.164 28.7783C122.332 28.9664 122.416 29.2293 122.416 29.567V31.265H121.903V29.6297C121.903 29.3939 121.859 29.2203 121.769 29.1099C121.678 28.9996 121.524 28.9441 121.306 28.9441H120.461Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M124.677 28.9441H122.974V28.4961H125.19V31.265H124.677V28.9441H124.677ZM123.023 31.265V29.6743L123.544 29.6786V31.265H123.023Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M127.252 30.4985V28.4954H129.436V29.4722L129.441 31.2643H128.923V28.9434H127.764V30.5208C127.764 30.7451 127.705 30.9248 127.589 31.0605C127.472 31.1961 127.301 31.2643 127.076 31.2643H126.807V30.8114H126.977C127.076 30.8114 127.147 30.7867 127.188 30.7373C127.23 30.6878 127.251 30.6082 127.251 30.4973L127.252 30.4985Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M131.544 28.4508H131.571C131.82 28.4508 132.017 28.5334 132.162 28.6992C132.308 28.8651 132.38 29.1002 132.38 29.4047V31.2643H131.167V30.8163H131.868V29.4361C131.868 29.2835 131.836 29.1569 131.771 29.055C131.706 28.9537 131.608 28.9024 131.477 28.9024H131.454C131.415 28.9024 131.374 28.9085 131.331 28.9205C131.287 28.9326 131.233 28.9573 131.167 28.9947C131.101 29.0321 131.05 29.0616 131.012 29.0845C130.975 29.1068 130.904 29.1527 130.801 29.2214C130.698 29.2902 130.626 29.3366 130.587 29.3601V31.2643H130.075V28.4954H130.578L130.587 28.8584C130.824 28.7059 131.008 28.6003 131.14 28.54C131.272 28.4803 131.407 28.4502 131.545 28.4502L131.544 28.4508Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M132.942 28.4961H133.455V29.8896C133.455 30.2152 133.542 30.4594 133.718 30.6222C133.893 30.785 134.114 30.8664 134.381 30.8664H134.421C134.691 30.8664 134.913 30.785 135.089 30.6222C135.264 30.4594 135.352 30.2152 135.352 29.8896V28.4961H135.864V29.8896C135.864 30.3141 135.732 30.6578 135.469 30.9225C135.205 31.1866 134.856 31.3193 134.422 31.3193H134.381C133.95 31.3193 133.602 31.1872 133.339 30.9225C133.075 30.6584 132.943 30.3141 132.943 29.8896V28.4961H132.942ZM134.151 28.4961H134.646V30.2526L134.151 30.2484V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M136.412 28.9441V28.4961H137.531V30.4992C137.531 30.732 137.463 30.9183 137.326 31.057C137.19 31.1957 137.005 31.2656 136.771 31.2656H136.223V30.8176H136.735C136.819 30.8176 136.887 30.7893 136.939 30.7326C136.992 30.6759 137.018 30.5921 137.018 30.4817V28.9447H136.411L136.412 28.9441Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M139.302 28.4961H139.814V30.0283H139.302V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M140.331 28.4961H140.843V31.265H140.331V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M143.49 28.4961L142.605 31.2651H142.065L142.812 28.9442H141.369V27.8196H141.886V28.4961H143.491H143.49Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M143.972 28.4961H144.484V30.0283H143.972V28.4961Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M146.641 30.0554V28.4961H147.149V30.0687C147.149 30.1881 147.136 30.2996 147.108 30.4027C147.081 30.5059 147.037 30.6072 146.976 30.7073C146.914 30.8073 146.828 30.8942 146.715 30.9671C146.603 31.0401 146.469 31.0962 146.313 31.1354L144.853 31.4942V31.0329L145.491 30.8761L144.956 28.4967H145.482L145.98 30.7597L146.142 30.7193C146.313 30.6777 146.438 30.606 146.519 30.504C146.6 30.4027 146.641 30.2532 146.641 30.056V30.0554Z",
    fill: "#242056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M149.742 28.4961L148.857 31.2651H148.317L149.064 28.9442H147.621V27.8196H148.138V28.4961H149.743H149.742Z",
    fill: "#242056"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4388_20111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fafdf66d1bb2d4e0e526e2463463672f.svg";
export { ForwardRef as ReactComponent };